import axios from 'axios';
import { clearAppState, refreshTokenIfNeeded } from './authUtils';
import { currentEnv, getWithCredentialsOption } from './endpoints';

// Create an instance of Axios for JWT token interception.
const jwtInterceptor = axios.create({
	withCredentials: true,
});
// Request interceptor: Check and refresh the token before any request is made
jwtInterceptor.interceptors.request.use(
	async (config) => {
		const withCredentials = getWithCredentialsOption(currentEnv);
		// If the current environment is set to be UAT or PROD, we use withCredentials
		if (withCredentials) {
			config.withCredentials = true;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// Response interceptor: Handle token refresh on 401 (Unauthorized) errors.
jwtInterceptor.interceptors.response.use(
	(response) => response,
	async (error) => {
		const originalRequest = error.config;
		console.log('Original request retry', originalRequest._retry);
		// console.log('jwtInterceptor.interceptors.response ERROR', error);
		if (error?.response?.status === 401 && !originalRequest._retry) {
			originalRequest._retry = true;
            await refreshTokenIfNeeded();
            return await jwtInterceptor(originalRequest);
		} else if (error?.response?.status === 401) {
			// If response status is 401 (unauthorised), remove data from local storage and cookies
			clearAppState();
			return Promise.reject(error);
		}
		return Promise.reject(error);
	}
);

// Export the Axios instance with JWT token interception.
export default jwtInterceptor;
